import gql from "graphql-tag";

export const SEARCH_CRITERIA_QUERY = gql`
    query SearchCriteria($item: String!, $searchType: SearchType!, $productType: Int!) {
        search {
            criteria(item: $item, searchType: $searchType, productType: $productType)
        }
    }
`;
